<template>
  <div class="p-5" style="border-radius: 2rem; background: #F6F6F6;">
    <BRow>
       <BCol cols="12">
        <BRow v-if="!currentChapterData.id">
          <BCol cols="3">
            <BFormGroup>
              <label for="chapter-name">
                Ім’я розділу <span class="text-danger">*</span>
              </label>
              <BInput
                  v-model="currentChapterData.name"
                  id="chapter-name"
                  class="shadow-none"
              />
            </BFormGroup>
          </BCol>
        </BRow>
         <BRow>
           <BCol cols="3">
             <BFormGroup>
               <label for="chapter-artist">
                 Виконувач <span class="text-danger">*</span>
               </label>
               <vue-simple-suggest
                   v-model="currentChapterData.artist"
                   :list="getSuggestionList"
                   :filter-by-query="true">
                 <!-- Filter by input text to only show the matching results -->
               </vue-simple-suggest>
             </BFormGroup>
           </BCol>
           <BCol cols="3" />
           <BCol cols="6">
             <BFormGroup>
               <label for="chapter-full-name">
                 Повна назва частини
               </label>
               <BInput
                   v-model="currentChapterData.fullName"
                   id="chapter-full-name"
                   class="shadow-none"
               />
             </BFormGroup>
           </BCol>
         </BRow>
        <BRow>
          <BCol cols="3">
            <BFormGroup>
              <label for="chapter-audio">Завантажити аудіофайл
                <span class="text-danger">*</span>
                <span>
                  <font-awesome-icon
                      :icon="['far', 'question-circle']"
                  />
                </span>
              </label>
              <div v-if="!currentChapterData.link">
                <vue-dropzone
                    ref="myVueDropzone"
                    id="dropzone"
                    @vdropzone-success="addAudioSuccess"
                    :options="setChapterIdForDropzoneOptions()" />
              </div>
              <div v-else class="text-success">
                <BButton @click="changeAudio">Змінити аудiо</BButton>
                <font-awesome-icon :icon="['fas', 'check']" /> Completed !
              </div>
            </BFormGroup>
          </BCol>
        </BRow>
        <BRow>
          <BCol cols="12">
            <BFormGroup>
              <label for="chapter-text">
                Текстова версія <span class="text-danger">*</span>
              </label>
              <editor
                  :init="config"
                  v-model="currentChapterData.text"
                  apiKey="fc7ai2v2d0leikwj7oji7iwcr41hifts6pjt7gwrntvzglhu"
              />
            </BFormGroup>
          </BCol>
        </BRow>
      </BCol>
    </BRow>
    <BRow>
      <BCol md="2">
        <RouterLink :to="{ name: 'AudioEditor', params: { id: $route.params.id, chapterId: currentChapterData.id }}" :class="isSynchronized" class="pt-3 btn btn-success btn-lg m-l-20" style="font-size: 15px">
          Cинхронізувати
        </RouterLink>
      </BCol>
      <BCol md="6">
      </BCol>
      <BCol md="2">
        <button @click="toClearForm" class="btn btn-outline-secondary btn-lg mt-auto mb-auto bg-white" style="font-size: 15px">
          <i class="mdi mdi-close-circle"></i> Скасувати
        </button>
      </BCol>
      <BCol md="2">
        <button @click="updateCurrentChapter" class="btn btn-success btn-lg m-l-20" type="submit" style="font-size: 15px"><i
            class="mdi mdi-check-circle"></i> Зберегти
        </button>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import * as chapterGetters from "../../../store/modules/Chapter/types/getters";
import * as chapterActions from "../../../store/modules/Chapter/types/actions";
import { mapGetters,mapActions } from "vuex";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import axios from "axios";
import Editor from '@tinymce/tinymce-vue'

export default {
  name: "AddChaptersForm",
  components: {
    vueDropzone: vue2Dropzone,
    VueSimpleSuggest,
    Editor
  },
  props: {
    audioFile: String,
    currentChapterData: Object
  },
  data(){
    return {
      chosen: '',
      dropzoneOptions: {
        url: process.env.MIX_APP_URL + '/api/chapters/audio',
        params: {
          id: null
        },
        maxFiles: 1,
        paramsName: 'file',
        method: 'patch',
        maxFilesize: 1024,
        timeout: 180000,
        headers: { "My-Awesome-Header": "header value" }
      },
      config: {
        height: 500,
        menubar: false,
        plugins: [
          'advlist autolink lists link image charmap',
          'searchreplace visualblocks code fullscreen',
          'print preview anchor insertdatetime media',
          'paste code help wordcount table'
        ],
        toolbar:
            'undo redo | formatselect | bold italic | \
            alignleft aligncenter alignright | \
            bullist numlist outdent indent | help'
      }
    };
  },
  computed: {
    ...mapGetters('Chapter', {
      currentChapter: chapterGetters.GET_CHAPTER,
      // getArtists: chapterGetters.GET_ARTISTS
    }),
    isSynchronized() {
      // return this.currentChapterData.name !== ''
      //   && this.currentChapterData.fullName !== ''
      //   && this.currentChapterData.artist !== ''
      //   && this.currentChapterData.text !== ''
      //   && this.currentChapterData.link !== null
      // ? '' : 'disabled'

      return this.currentChapterData.artist !== ''
      && this.currentChapterData.text !== ''
      && this.currentChapterData.link !== null
          ? '' : 'disabled'
    }
  },
  watch: {
  },
  methods: {
    getSuggestionList() {
      return  axios
          .post(`/api/chapters/get-artists/?choice=${this.currentChapterData.artist}`)
          .then(response => response.data)
          .catch(err => console.log(err));
    },
    setChapterIdForDropzoneOptions(){
      this.dropzoneOptions.params.id = this.currentChapter.id;
      return this.dropzoneOptions;
    },
    setNotification(variant, message) {
      Swal.fire(
          message,
          '',
          variant
      )
    },
    ...mapActions('Chapter', {
      updateChapter: chapterActions.UPDATE_CHAPTER,
      addAudio: chapterActions.ADD_AUDIO_FOR_CURRENT_CHAPTER,
      deleteAudio: chapterActions.DELETE_AUDIO_FOR_CURRENT_CHAPTER,
      deleteChapter: chapterActions.DELETE_CHAPTER,
      getArtists: chapterActions.GET_ARTISTS,
    }),
    changeAudio(){
      this.deleteAudio({
        id: this.currentChapterData.id
      });
      this.$emit('selectedChapter')
    },
    addAudioSuccess(data, response) {
      this.currentChapterData.link = response.link;
    },
    toClearForm() {
      this.currentChapterData.name = this.currentChapter.name;
      this.currentChapterData.fullName = this.currentChapter.fullName;
      this.currentChapterData.artist = this.currentChapter.artist;
      this.currentChapterData.text = this.currentChapter.text;
      this.currentChapterData.link = this.currentChapter.link;
    },
    updateCurrentChapter() {
      try {
        this.updateChapter(this.currentChapterData)
          .then(
            this.setNotification('success', 'Глава успішно збережена')
          );
      } catch (err) {
        console.log(err);
      }
    },
  }
}
</script>

<style scoped>
.disabled {
  cursor: not-allowed;
  background: #808080;
  border: none;
}
</style>